import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

function InputLevels({ type, name, value, onChange, required, error }) {
  const { t } = useTranslation();
  const { levels } = useSelector((state) => state.genericReducer);

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("LEVEL")}</label>
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <div className="select-wrapper">
        <select name={name} value={value} onChange={(e) => onChange(e, name)}>
          <option value={""}> {t("SELECT")}</option>
          {levels.map((option) => (
            <option key={option.level} value={option.id}>
              {" "}
              {option.level}{" "}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default InputLevels;
